module.exports = __webpack_public_path__ + "static/media/ro.a9184b42.jpg";